import React, { useState, useEffect, useRef } from "react";
import Menu1 from "../Menu";
import Header from "../Header";
import Footer from "../Footer";
import { Select, Switch, Tooltip } from "antd";
import { DatePicker } from "antd";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  assetList,
  doGetAssetsList,
  getSelectedAssetSubCategory,
  getAssetName,
  SaveAssetDetails,
  _doChangeStep,
  _doNextAction,
  doSubmit,
  retainCursorOnInputChange,
} from "./actions/assetsService";
import MessageBox from "../../UIComponents/MessageBox/MessageBox";
import Spinner from "../../helpers/shared/Spinner";
import dayjs from "dayjs";
import ValidationsMessage from "../../helpers/shared/ValidationsMessage";
import VendorDetails from "./VendorDetails";
import { scope } from "../../constants/Constants";

const { Option } = Select;

export default function AddAsset() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [stepCount, setStepCount] = useState(1);
  const [subCategory, setSubCategory] = useState("");
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [isSubmit, setSubmit] = useState(false);
  const assetDetails = useSelector((state) => state?.assetList?.AssetsDetail);
  const status = useSelector((state) => state?.assetList);
  const [stepFormList, setStepFormList] = useState([
    {
      Style: "inprogress",
      Label: "Asset Details",
      Index: 1,
      Icon: "fa fa-cogs",
    },
    {
      Style: "",
      Label: "Vendor Details",
      Index: 2,
      Icon: "fa fa-user",
    },
  ]);
  const [vendorInfo, setVendorInfo] = useState([]);
  const [addForm, setAddForm] = useState({
    store: "",
    subCategory: "",
    lot: "",
    active: true,
    assetName: "",
    available: "",
    comments: "",
    location: "",
    installationBy: "",
    maintenanceYear1: "",
    maintenanceAfterYear1: "",
    repairWorks: "",
    reinvestment: "",
    make: "",
    modelNo: "",
    serialNo: "",
    capacityType: "",
    capacityValue: "",
    totalNo: "",
    installationDate: "",
    warranty: "",
    lifeOfAsset: "",
    vendor: "",
  });

  const _doNavToAssets = () => {
    dispatch(assetList(true));
    navigate("/Assets");
  };
  useEffect(() => {
    setStepFormList(() => _doChangeStep(stepFormList, stepCount));
  }, [stepCount]);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
    }
  }, [addForm.assetName, cursorPosition]);

  const selectSubCat = (value) => {
    setSubCategory(value);
    let filteredData = assetDetails?.SubCategory.filter(
      (ele) => ele.id == value
    );
    dispatch(getSelectedAssetSubCategory(filteredData[0]));
  };
  const selectVendor = (value) => {
    let filteredData = assetDetails?.VendorList.filter(
      (ele) => ele.rowid == value
    );
    setAddForm({ ...addForm, vendor: value });
    setVendorInfo(filteredData[0]);
  };
  const changeStoreHandler = (value) => {
    dispatch(getAssetName(value));
    setSubCategoryData(assetDetails?.SubCategory);
  };
  return (
    <div className="wrapper">
      <Header title={"Create New Asset"} />
      <Menu1 />
      {status?.modalOpen && status?.message != undefined && (
        <MessageBox
          message={status?.message}
          onClose={() => {
            if (status?.apiStatus) {
              dispatch(doGetAssetsList());
            }
          }}
        />
      )}
      <Spinner isLoading={status.loading}>
        <div className="content-wrapper">
          <section className="content top-space">
            <div className="m-panel">
              <div className="m-panel__body pb-10">
                <div className="m-step-form">
                  <div className="m-step-form__container">
                    <div className="m-step-form__list">
                      {stepFormList.map((item) => (
                        <div
                          className={"m-step-form__item " + item.Style}
                          key={item.Index}
                        >
                          <div className="m-step-form__item--box">
                            <span className={item.Icon}></span>
                          </div>
                          <h5 className="m-step-form__item--lbl">
                            {item.Label}
                          </h5>
                        </div>
                      ))}
                    </div>
                    <div className="m-step-form__content">
                      {stepCount === 1 && (
                        <div className="row m-grid">
                          <div className="col-md-12">
                            <h5 className="m-panel__subtitle">Asset Details</h5>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">Store*</label>
                              <Select
                                className="form-control"
                                showSearch
                                onChange={(value) => {
                                  setAddForm({ ...addForm, store: value });
                                  changeStoreHandler(value);
                                }}
                                value={addForm.store}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {assetDetails?.StoreList?.map((item) => (
                                  <Option
                                    key={item.store_id}
                                    value={item.store_id}
                                  >
                                    {item.store_name}
                                  </Option>
                                ))}
                              </Select>
                              <ValidationsMessage
                                field={addForm.store}
                                isSubmit={isSubmit}
                                message="Please Select Store"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Sub category*
                              </label>
                              <div className="flex-wrapper">
                                <Select
                                  className="form-control"
                                  showSearch
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  value={subCategory}
                                  onChange={(value) => {
                                    selectSubCat(value);
                                  }}
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                >
                                  {subCategoryData?.map((item) => (
                                    <Option key={item.id} value={item.id}>
                                      {item.name}
                                    </Option>
                                  ))}
                                </Select>
                                <Tooltip
                                  title={"Create new Sub Category"}
                                  placement="right"
                                  overlayClassName="asset-health-card-tooltip-overlay"
                                >
                                  <div
                                    className="m-btn-block__icon"
                                    onClick={() => {
                                      navigate("/AssetCategories");
                                    }}
                                  >
                                    <i
                                      className="fa fa-plus-circle"
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                </Tooltip>
                              </div>
                              <ValidationsMessage
                                field={subCategory}
                                isSubmit={isSubmit}
                                message="Please Select Sub Category"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">Lot*</label>
                              <Select
                                className="form-control"
                                showSearch
                                onChange={(value) =>
                                  setAddForm({ ...addForm, lot: value })
                                }
                                value={addForm?.lot}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {assetDetails?.LotSet?.map((item) => (
                                  <Option key={item.name} value={item.value}>
                                    {item.name}
                                  </Option>
                                ))}
                              </Select>
                              <ValidationsMessage
                                field={addForm.lot}
                                isSubmit={isSubmit}
                                message="Please Select Lot"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">Status*</label>
                              <Switch
                                checkedChildren="Active"
                                onChange={(status) =>
                                  setAddForm({ ...addForm, active: status })
                                }
                                defaultChecked={addForm.active}
                              />
                              <ValidationsMessage
                                field={addForm.active}
                                isSubmit={isSubmit}
                                message="Please Select Status"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">Asset name*</label>
                              <input
                                ref={inputRef}
                                value={addForm?.assetName}
                                type="text"
                                className="form-control"
                                maxLength="100"
                                onChange={(e) => {
                                  retainCursorOnInputChange(
                                    e,
                                    setAddForm,
                                    addForm,
                                    setCursorPosition,
                                    "assetName"
                                  );
                                }}
                              />
                              <ValidationsMessage
                                field={addForm.assetName}
                                isSubmit={isSubmit}
                                message="Please Select Asset Name"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Availability*
                              </label>
                              <select
                                className="form-control m-form__input"
                                onChange={(e) =>
                                  setAddForm({
                                    ...addForm,
                                    available: e.target.value,
                                  })
                                }
                                value={addForm.available}
                              >
                                <option>-- Please Select --</option>
                                <option value="AVAILABLE">AVAILABLE</option>
                                <option value="NOT AVAILABLE">
                                  NOT AVAILABLE
                                </option>
                              </select>
                              <ValidationsMessage
                                field={addForm.available}
                                isSubmit={isSubmit}
                                message="Please Select Availability"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group  cl">
                              <label htmlFor="exampleInput">Comments</label>
                              <textarea
                                value={addForm.comments}
                                type="texta"
                                className="form-control"
                                maxLength="100"
                                onChange={(e) =>
                                  setAddForm({
                                    ...addForm,
                                    comments: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">Location*</label>
                              <input
                                type="text"
                                className="form-control"
                                value={addForm.location}
                                onChange={(e) =>
                                  setAddForm({
                                    ...addForm,
                                    location: e.target.value,
                                  })
                                }
                              />
                              <ValidationsMessage
                                field={addForm.location}
                                isSubmit={isSubmit}
                                message="Please Select Location"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Installation by (DSI/LL)*
                              </label>
                              <Select
                                className="form-control"
                                showSearch
                                onChange={(value) =>
                                  setAddForm({
                                    ...addForm,
                                    installationBy: value,
                                  })
                                }
                                value={addForm.installationBy}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {scope?.map((item) => (
                                  <Option key={item.name} value={item.name}>
                                    {item.name}
                                  </Option>
                                ))}
                              </Select>
                              <ValidationsMessage
                                field={addForm.installationBy}
                                isSubmit={isSubmit}
                                message="Please Select Installation By"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Maintenance Year 1 (DSI/LL)*
                              </label>
                              <Select
                                className="form-control"
                                showSearch
                                onChange={(value) =>
                                  setAddForm({
                                    ...addForm,
                                    maintenanceYear1: value,
                                  })
                                }
                                value={addForm.maintenanceYear1}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {scope?.map((item) => (
                                  <Option key={item.name} value={item.name}>
                                    {item.name}
                                  </Option>
                                ))}
                              </Select>
                              <ValidationsMessage
                                field={addForm.maintenanceYear1}
                                isSubmit={isSubmit}
                                message="Please Select Maintenance Year 1"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Maintenance After Year 1 (DSI/LL)*
                              </label>
                              <Select
                                className="form-control"
                                showSearch
                                onChange={(value) =>
                                  setAddForm({
                                    ...addForm,
                                    maintenanceAfterYear1: value,
                                  })
                                }
                                value={addForm.maintenanceAfterYear1}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {scope?.map((item) => (
                                  <Option key={item.name} value={item.name}>
                                    {item.name}
                                  </Option>
                                ))}
                              </Select>
                              <ValidationsMessage
                                field={addForm.maintenanceAfterYear1}
                                isSubmit={isSubmit}
                                message="Please Select Maintenance After Year 1"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Repair Works (DSI/LL)*
                              </label>
                              <Select
                                className="form-control"
                                showSearch
                                onChange={(value) =>
                                  setAddForm({ ...addForm, repairWorks: value })
                                }
                                value={addForm.repairWorks}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {scope?.map((item) => (
                                  <Option key={item.name} value={item.name}>
                                    {item.name}
                                  </Option>
                                ))}
                              </Select>
                              <ValidationsMessage
                                field={addForm.repairWorks}
                                isSubmit={isSubmit}
                                message="Please Select Repair Works"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Reinvestment (DSI/LL)*
                              </label>
                              <Select
                                className="form-control"
                                showSearch
                                onChange={(value) =>
                                  setAddForm({
                                    ...addForm,
                                    reinvestment: value,
                                  })
                                }
                                value={addForm.reinvestment}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {scope?.map((item) => (
                                  <Option key={item.name} value={item.name}>
                                    {item.name}
                                  </Option>
                                ))}
                              </Select>
                              <ValidationsMessage
                                field={addForm.reinvestment}
                                isSubmit={isSubmit}
                                message="Please Select Reinvestment"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">Make/Brand*</label>
                              <input
                                value={addForm.make}
                                type="text"
                                className="form-control"
                                onChange={(e) =>
                                  setAddForm({
                                    ...addForm,
                                    make: e.target.value,
                                  })
                                }
                              />
                              <ValidationsMessage
                                field={addForm.make}
                                isSubmit={isSubmit}
                                message="Please Select Make/brand"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Model Number*
                              </label>
                              <input
                                value={addForm.modelNo}
                                type="text"
                                className="form-control"
                                onChange={(e) =>
                                  setAddForm({
                                    ...addForm,
                                    modelNo: e.target.value,
                                  })
                                }
                              />
                              <ValidationsMessage
                                field={addForm.modelNo}
                                isSubmit={isSubmit}
                                message="Please Select Model Number"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Serial Number*
                              </label>
                              <input
                                value={addForm.serialNo}
                                type="text"
                                className="form-control"
                                onChange={(e) =>
                                  setAddForm({
                                    ...addForm,
                                    serialNo: e.target.value,
                                  })
                                }
                              />
                              <ValidationsMessage
                                field={addForm.serialNo}
                                isSubmit={isSubmit}
                                message="Please Select Serial Number"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Capacity Type - Units*
                              </label>
                              <Select
                                className="form-control"
                                showSearch
                                onChange={(value) =>
                                  setAddForm({
                                    ...addForm,
                                    capacityType: value,
                                  })
                                }
                                value={addForm.capacityType}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {assetDetails?.CapacityType?.map((item) => (
                                  <Option key={item.name} value={item.value}>
                                    {item.name}
                                  </Option>
                                ))}
                              </Select>
                              <ValidationsMessage
                                field={addForm.capacityType}
                                isSubmit={isSubmit}
                                message="Please Select Capacity Type"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Capacity Value*
                              </label>
                              <input
                                value={addForm.capacityValue}
                                type="number"
                                className="form-control"
                                onChange={(e) =>
                                  setAddForm({
                                    ...addForm,
                                    capacityValue: e.target.value
                                      .replace(/[^0-9.]/g, "") // Remove all non-numeric characters except the decimal point
                                      .replace(/(\..*)\./g, "$1"), // Prevent more than one decimal point
                                  })
                                }
                              />
                              <ValidationsMessage
                                field={addForm.capacityValue}
                                isSubmit={isSubmit}
                                message="Please Select Capacity Value"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Total Number*
                              </label>
                              <input
                                value={addForm.totalNo}
                                type="number"
                                className="form-control"
                                onChange={(e) =>
                                  setAddForm({
                                    ...addForm,
                                    totalNo: e.target.value
                                      .replace(/[^0-9.]/g, "") // Remove all non-numeric characters except the decimal point
                                      .replace(/(\..*)\./g, "$1"), // Prevent more than one decimal point
                                  })
                                }
                              />
                              <ValidationsMessage
                                field={addForm.totalNo}
                                isSubmit={isSubmit}
                                message="Please Select Total Number"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Installation Date*
                              </label>
                              <DatePicker
                                className="form-control"
                                defaultValue={
                                  addForm.installationDate.length
                                    ? dayjs(
                                        addForm.installationDate,
                                        "DD-MM-YYYY"
                                      )
                                    : null
                                }
                                format={"DD-MM-YYYY"}
                                onChange={(date, dateString) =>
                                  setAddForm({
                                    ...addForm,
                                    installationDate: dateString,
                                  })
                                }
                              />
                              <ValidationsMessage
                                field={addForm.installationDate}
                                isSubmit={isSubmit}
                                message="Please Select Installation Date"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Warranty in Months*
                              </label>
                              <input
                                value={addForm.warranty}
                                type="text"
                                className="form-control"
                                onChange={(e) =>
                                  setAddForm({
                                    ...addForm,
                                    warranty: e.target.value.replace(
                                      /[^0-9]/g,
                                      ""
                                    ),
                                  })
                                }
                              />
                              <ValidationsMessage
                                field={addForm.warranty}
                                isSubmit={isSubmit}
                                message="Please Select Warranty"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="exampleInput">
                                Life of asset (in Years)*
                              </label>
                              <input
                                value={addForm.lifeOfAsset}
                                type="text"
                                className="form-control"
                                onChange={(e) =>
                                  setAddForm({
                                    ...addForm,
                                    lifeOfAsset: e.target.value
                                      .replace(/[^0-9.]/g, "") // Remove all non-numeric characters except the decimal point
                                      .replace(/(\..*)\./g, "$1"), // Prevent more than one decimal point
                                  })
                                }
                              />
                              <ValidationsMessage
                                field={addForm.lifeOfAsset}
                                isSubmit={isSubmit}
                                message="Please Select Life of Asset"
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {stepCount === 2 && (
                        <VendorDetails
                          selectVendor={selectVendor}
                          addForm={addForm}
                          assetDetails={assetDetails}
                          vendorInfo={vendorInfo}
                          isSubmit={isSubmit}
                        />
                      )}
                      <div className="row">
                        <div className="col-md-12 text-right">
                          <div className="m-page__button top-space">
                            {stepCount > 1 && (
                              <button
                                type="button"
                                onClick={() =>
                                  setStepCount((stepCount) => stepCount - 1)
                                }
                                className="btn muted-button  deca-btn-orange"
                              >
                                Prev
                              </button>
                            )}
                            {stepCount < 2 && (
                              <button
                                type="button"
                                onClick={() => {
                                  _doNextAction(
                                    setSubmit,
                                    addForm.store,
                                    subCategory,
                                    stepCount,
                                    setStepCount
                                  );
                                }}
                                className="btn btn-secondary deca-btn-yellow"
                              >
                                Next
                              </button>
                            )}
                            {subCategory.length != 0 && (
                              <button
                                type="button"
                                className="btn muted-button  deca-btn-yellow"
                                onClick={() => {
                                  doSubmit(
                                    setSubmit,
                                    addForm,
                                    subCategory,
                                    stepCount,
                                    SaveAssetDetails,
                                    dispatch
                                  );
                                }}
                              >
                                Submit
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 text-right">
                <div className="m-page__button top-space">
                  <button
                    type="button"
                    onClick={_doNavToAssets}
                    className="btn muted-button  deca-btn-orange"
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Spinner>
      <Footer />
    </div>
  );
}
